"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
const enc_utf8_1 = __importDefault(require("crypto-js/enc-utf8"));
const hmac_sha256_1 = __importDefault(require("crypto-js/hmac-sha256"));
exports.base64url = (source) => {
    /* Encode in classical base64 */
    let encodedSource = enc_base64_1.default.stringify(source);
    /* Remove padding equal characters */
    encodedSource = encodedSource.replace(/=+$/, "");
    /* Replace characters according to base64url specifications */
    encodedSource = encodedSource.replace(/\+/g, "-");
    encodedSource = encodedSource.replace(/\//g, "_");
    return encodedSource;
};
exports.stringify64 = (mixed) => exports.base64url(enc_utf8_1.default.parse(JSON.stringify(mixed)));
exports.encodeJWT = (authPayload, secret) => {
    const header = {
        alg: "HS256",
        typ: "JWT",
    };
    /* Prepare token parts */
    const encodedHeader = exports.stringify64(header);
    const encodedData = exports.stringify64(authPayload);
    /* Compile unsigned token */
    const token = `${encodedHeader}.${encodedData}`;
    /* Sign Token */
    const signature = hmac_sha256_1.default(token, secret);
    const signedToken = `${token}.${exports.base64url(signature)}`;
    return signedToken;
};
exports.createPayload = (tokenId, path, device, nonce) => {
    const payload = {
        path,
        token_id: tokenId,
        nonce: nonce === undefined ? Date.now() : nonce,
    };
    if (device !== undefined) {
        payload.device = device;
    }
    return payload;
};
exports.resolveAuthToken = (authToken, path, callback, nonce) => {
    return callback(exports.encodeJWT(exports.createPayload(authToken.tokenId, path, authToken.device, nonce), authToken.tokenSecret));
};
const resolveAuthFuncSimple = (authFuncSimple, path, callback) => {
    const funcResult = authFuncSimple({ path });
    if (typeof funcResult === "string") {
        return callback(funcResult);
    }
    if (funcResult instanceof Promise) {
        return new Promise((resolve, reject) => {
            funcResult
                .then((jwt) => {
                callback(jwt).then(resolve).catch(reject);
            })
                .catch(reject);
        });
    }
    return Promise.reject("AuthFunction should either return a string or a promise");
};
const resolveRuthFuncWithCallback = (authFuncWithCallback, path, callback) => {
    // Return a promise to the Connection object which called this
    return new Promise((outerResolve, outerReject) => {
        authFuncWithCallback({ path }, (jwt) => {
            // Return a promise to the external library to release the nonce
            return new Promise((innerResolve) => {
                callback(jwt)
                    .then(() => {
                    outerResolve();
                    innerResolve();
                })
                    .catch((e) => {
                    outerReject();
                    // external jwt libraries don't care whether this succeeded
                    innerResolve();
                });
            });
        });
    });
};
exports.resolveAuth = (auth, path, nonce) => (callback) => {
    let funcResult = null;
    switch (typeof auth) {
        case "string":
            return callback(auth);
        case "object":
            return exports.resolveAuthToken(auth, path, callback, nonce);
        case "function":
            if (auth.length === 1 || auth.length === 0) {
                const promise = resolveAuthFuncSimple(auth, path, callback);
                if (promise !== undefined) {
                    return promise;
                }
            }
            else if (auth.length === 2) {
                return resolveRuthFuncWithCallback(auth, path, callback);
            }
    }
    const allowObjects = [
        "(string containing jwt)",
        '{ tokenId: "", tokenSecret: "" }',
        "[Function] (params: object) => string",
        "[Function] (params: object) => Promise<string>",
        "[Function] (params: object, callback: [(jwt: string) => void]) => void",
    ];
    throw new Error(`Invalid auth object:\n${JSON.stringify(auth)}\n\nMust be one of:\n - ${allowObjects.join("\n - ")}\n\n`);
};
